module.exports = __webpack_public_path__ + "static/ipad-statusbar-98d52351a463c1e2c24f2e1c6dd12102.jpg";